export function sidebarIcon(collapsed) {
  return (
    <svg
      width={"22"}
      height={"22"}
      viewBox={"0 0 24 24"}
      fill={"none"}
      stroke={"currentColor"}
      strokeWidth={"1.7"}
      strokeLinecap={"round"}
      strokeLinejoin={"round"}
      aria-hidden={"true"}
    >
      <rect x={"3"} y={"4"} width={"18"} height={"16"} rx={"2"}></rect>
      <path d={"M9 4v16"}></path>
      <path d={collapsed ? "M13 9l3 3-3 3" : "M16 9l-3 3 3 3"}></path>
    </svg>
  );
}
